import { ActivitiesService } from "services/activities.service";
import { CoursesService } from "services/courses.service";


export class ResourcesService {
    activitiesService;
    coursesService;

    constructor() {
        this.activitiesService = new ActivitiesService();
        this.coursesService = new CoursesService();
    }

    loadResourcesByPath = async (pathname: string) => {
        const activities = await this.activitiesService.getActivities();
        const courses = await this.coursesService.getCourses();

        let filteredActivities = [];
        let filteredCourses = [];

        if (pathname === '/') {
            filteredActivities = activities?.filter((a) => a.status !== "Finished") || [];
            filteredCourses = courses?.filter((c) => c.status !== "FINISHED") || [];
            return {
                titleKey: 'title_activities_todo',
                data: [...filteredActivities, ...filteredCourses],
            };
        } else if (pathname === '/done') {
            filteredActivities = activities?.filter((a) => a.status === "Finished") || [];
            filteredCourses = courses?.filter((c) => c.status === "FINISHED") || [];
            return {
                titleKey: 'title_activities_done',
                data: [...filteredActivities, ...filteredCourses],
            };
        }

        return { titleKey: '', data: [] };
    }


}